import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth/withWidth';
import ProductPartsList from '../../../Creator/Components/ProductPartsList';

const styles = () => ({

});

export const DesignPicker = withWidth({ initialWidth: 'lg' })(
  withStyles(styles, { name: 'DesignPicker' })(
    ({
      selectedDesignArea, designAreas, handleChangeDesignArea, openDesignArea,
      addOptionsRef, width,
    }) => (
      <>
        {isWidthUp('sm', width)
          && (
            <ProductPartsList
              onSelect={(e) => {
                handleChangeDesignArea(e.identifier);
                openDesignArea();
              }}
              optionclassifications={designAreas}
              displaySwitchedOptions
              vertical={false}
              refToStateFunc={addOptionsRef}
              selectedoptionclassification={selectedDesignArea ? designAreas.find((area) => area.identifier === selectedDesignArea.identifier) : null}
              showMarker
            />
          )}
      </>
    ),
  ),
);

export default DesignPicker;
